import { Section } from '../types/contentTemplate';
import { SectionDTO } from '../types';

export function sortSections<T extends Section | SectionDTO>(sections: T[]): T[] {
  return sections.sort((section1, section2) => {
    return section1.position - section2.position;
  });
}
